export default __webpack_public_path__ + "static/media/logo_nova_dark.3e47fcde.png";